module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MsWUUV/tc-custom/9781626811874.jpg?1702083506006",
      "alt": "This image is the cover for the book Forbidden Moon, The Moon Trilogy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Forbidden Moon, The Moon Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A childhood promise is kept when an old crush blossoms into blazing passion in this spellbinding historical romance set in the old West.")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("San Francisco, 1886")]), _vm._v(". When Buck Randall met Molly Lindquist, he knew she was the only woman he would ever love. Only a girl when they met, the prideful Buck promised to wait for her until she is old enough to become his."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" As an adult, Molly is looking for her ticket out of a life that she hates. Engaged to a powerful Texas rancher, she’s all but forgotten the pact she made as a child. But when Buck returns to her life, a romance is rekindled that burns too brightly to ignore, and a promise must be kept—at all costs . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Jane Bonander reaches to her readers’ hearts.” —"), _c('i', [_vm._v("RT Book Reviews")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane Bonander\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0